<template>
  <div class="alinhar-ajuda" v-if="temContasLocais()" >
    <label for="conta-local" class="required">Conta Local:</label>
    <select v-model="selected" @change="enviarEmit" id="conta-local">
      <option v-for="cl in contasLocais" :key="cl.id" :value="cl.contaLocal">
        {{ cl.contaLocal }} - {{ cl.descricao2 }}
      </option>
    </select>
  </div>
</template>
  
<script>
export default {
  name: 'ContaLocal',
  emits: ['cl-selecionado', 'contas-locais-change'],
  props: {
    siglaUnidade: {
      type: String,
      default: null
    },
    centroOrcamentario: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      contasLocais: [],
      selected: '',
    };
  },

  methods: {

    async getContasLocais() {
      //console.log("Chamou endpoint CL '/unidade/sigla/co/num' ");
      try {
        const path = '/unidade/' + this.siglaUnidade+'/co/' + this.centroOrcamentario;
        const response = await this.$axios.get(path);
        this.contasLocais = response.data;
      } catch (error) {
        if (error.response) {
          console.error('(buscando contas locais) Resposta do servidor com status:', error.response.status);
        } else {
          console.error('(buscando contas locais) Erro sem resposta do servidor:', error.message);
        }
      }
    },

    temContasLocais(){
      return this.contasLocais.length > 0 && this.contasLocais[0].contaLocal !== null;
    },

    enviarEmit() {
      this.$emit('cl-selecionado', this.selected);
    }
  },


  mounted() {
    // console.log("CO = ", this.centroOrcamentario);
    // console.log("Sigla = ", this.siglaUnidade);

    if (this.centroOrcamentario != null) {
      this.getContasLocais();
    } else {
        this.contasLocais = [];
    }
  },

  watch: {
    centroOrcamentario() {
      // console.log("valor de this.centroOrcamentario: ", this.centroOrcamentario);
      // console.log("valor de this.co: ", this.co);
      
      if (this.centroOrcamentario != null) {
        this.getContasLocais();
      } else {
        this.contasLocais = []
      }
    },

    contasLocais: {
      handler(newValue) {
        //validar se pelo menos algum item do array tem contaLocal <> null
        let temAlgumaConta = newValue.some(item => item.contaLocal !== null);
        
        this.$emit('contas-locais-change', temAlgumaConta);
      },
      immediate: true
    }
  }

};
</script>
  
<style scoped>
/* Adicione estilos específicos para o componente aqui, se necessário */
</style>